import React from 'react'
import { Widget } from 'features/types'
import { getLabel } from 'utils/widgetTypeUtil'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'

import { SideBySideWidgetsType } from '../types'
import RunSearchEffect from '../share/RunSearchEffect'
import PostSearchDataGuards from '../share/guards/PostSearchDataGuards'
import PreSearchDataGuards from '../share/guards/PreSearchDataGuards'
import SideBySide from '../share/SideBySide'
import InsightModal from '../share/InsightModal'
import useSelectedInsights from '../share/hooks/useSelectedInsights'

const SocialWebSideBySideWidget: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<SideBySideWidgetsType>(widgetId)

  const {
    isModalOpen,
    setIsModalOpen,
    selection,
    countType,
    detailSetting,
    handleClick,
    widgetSettingWithSelection
  } = useSelectedInsights(widgetSetting)

  return (
    <UnexpectedErrorBoundary>
      <PreSearchDataGuards widgetId={widgetId}>
        <RunSearchEffect widgetId={widgetId}>
          <PostSearchDataGuards widgetId={widgetId}>
            <SideBySide widgetId={widgetId} onCellClick={handleClick} />
          </PostSearchDataGuards>
        </RunSearchEffect>
      </PreSearchDataGuards>
      <InsightModal
        widgetSettingWithSelection={widgetSettingWithSelection}
        open={isModalOpen}
        title={widgetSetting?.name || getLabel(widgetSetting?.type)}
        countType={countType}
        selection={selection}
        onClose={() => {
          setIsModalOpen(false)
        }}
        detailSetting={detailSetting}
        viewOption={widgetSetting.viewOption!}
      />
    </UnexpectedErrorBoundary>
  )
}

export default SocialWebSideBySideWidget
